import { render, staticRenderFns } from "./ForumResponseReplies.vue?vue&type=template&id=ccb14b64&scoped=true"
import script from "./ForumResponseReplies.vue?vue&type=script&lang=js"
export * from "./ForumResponseReplies.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseReplies.vue?vue&type=style&index=0&id=ccb14b64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb14b64",
  null
  
)

export default component.exports